import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getRuntimeEnvironment, hasRuntimeEnvironment } from './environments/environment-runtime';

// Load runtime environment if available, otherwise use static environment
const activeEnvironment = hasRuntimeEnvironment() ? getRuntimeEnvironment() : environment;

// Update the static environment with runtime values for backward compatibility
if (hasRuntimeEnvironment()) {
  Object.assign(environment, activeEnvironment);
  console.log('Runtime environment loaded successfully');
} else {
  console.log('Using static environment configuration');
}

if (activeEnvironment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
